<template>
    <rkm-area
        class="pb-1"
        title="Administração de medicamentos"
        type="fieldset"
    >
        <rkm-row>
            <rkm-col
                class="mb-2"
                cols="12"
            >
                <rkm-form-checkbox
                    v-for="(administracaoMedicamento, index) in data.form.posConsulta.administracoesMedicamentos"
                    :key="index"
                    :value="administracaoMedicamento.id"
                    @change.native="handleadministracaoMedicamentoChange"
                    inline
                >
                    {{administracaoMedicamento.descricao}}
                </rkm-form-checkbox>
            </rkm-col>
        </rkm-row>
    </rkm-area>
</template>

<script>
export default {
    methods: {
        handleadministracaoMedicamentoChange(event) {
            const administracaoMedicamento = this.data.form.posConsulta.administracoesMedicamentos.find(administracaoMedicamento => administracaoMedicamento.id === parseInt(event.target.value))

            if (event.target.checked) {
                this.data.model.posConsulta.administracoesMedicamentos.push(parseInt(event.target.value))
            } else {
                this.data.model.posConsulta.administracoesMedicamentos.splice(this.data.model.posConsulta.administracoesMedicamentos.indexOf(parseInt(event.target.value)) , 1)
            }

            if (administracaoMedicamento.codigoProcedimento) {
                this.$emit('administracaoMedicamentoChange', {
                    checked: event.target.checked,
                    codigo: administracaoMedicamento.codigoProcedimento,
                })
            }
        },
    },
    props: {
        data: {type: Object, required: true},
    },
}
</script>